module.exports = __webpack_public_path__ + "static/img/diyExplained.31b7d1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diyExplained.png
// module id = rnYd
// module chunks = 1